var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83398 1.625H7.39648V0.8125C7.39648 0.365625 7.03086 0 6.58398 0H4.14648C3.69961 0 3.33398 0.365625 3.33398 0.8125V1.625H0.896484C0.449609 1.625 0.0839844 1.99063 0.0839844 2.4375V4.0625H0.916797L1.44492 11.8625C1.48555 12.4922 2.01367 13 2.66367 13H8.04648C8.67617 13 9.22461 12.4922 9.26523 11.8625L9.81367 4.0625H10.6465V2.4375C10.6465 1.99063 10.2809 1.625 9.83398 1.625ZM4.14648 0.8125H6.58398V1.625H4.14648V0.8125ZM8.47305 11.8016C8.45273 12.0047 8.29023 12.1875 8.0668 12.1875H2.66367C2.46055 12.1875 2.27773 12.025 2.25742 11.8016L1.7293 4.0625H8.98086L8.47305 11.8016ZM9.83398 3.25H0.896484V2.4375H9.83398V3.25Z",
    fill: "#605F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.daf4b4160620b8e99a9f1757637c0121.svg";
export { ForwardRef as ReactComponent };